import { first } from '@mntn-dev/utilities'

import type { AnyRoute } from '../route.ts'
import { getRoutes } from './get-routes.ts'

export const findRoute = (
  localPath: string | undefined,
  exact?: boolean
): AnyRoute | undefined => {
  if (localPath) {
    return first(getRoutes((route) => route.isMatch(localPath, exact)))
  }
}

export const assertFindRoute = (
  localPath: string | undefined,
  exact?: boolean
): AnyRoute => {
  const route = findRoute(localPath, exact)

  if (!route) {
    throw new Error(`Route not found for path: ${localPath}`)
  }

  return route
}

export type FindRouteAncestryOptions = {
  includeSelf?: boolean
  depth?: number
}
